import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = localStorage.getItem("ghh_admin_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export const createAppointment = (data) => api.post("/appointments", data).then((r) => r.data);
export const createEnquiry = (data) => api.post("/enquiries", data).then((r) => r.data);

export const adminLogin = (username, password) =>
  api.post("/admin/login", { username, password }).then((r) => r.data);
export const fetchAppointments = () => api.get("/admin/appointments").then((r) => r.data);
export const fetchEnquiries = () => api.get("/admin/enquiries").then((r) => r.data);
